import { ENotificationType } from "../interfaces";
import { useWatchBaseNotification, type IUseWatchBaseNotificationProps } from "./useWatchBaseNotification";

export type QuoteAcceptedNotificationPayload = {
  quoteId?: number;
  id?: number;
};

export const useWatchQuoteAcceptedNotifications = ({
  dissableSnackbarAlert = false,
  onNotificationArrived,
}: Omit<IUseWatchBaseNotificationProps<QuoteAcceptedNotificationPayload>, "notificationTypes" | "buildSnackbarMessage"> = {}) =>
  useWatchBaseNotification<QuoteAcceptedNotificationPayload>({
    notificationTypes: [ENotificationType.QuoteAccepted],
    dissableSnackbarAlert,
    onNotificationArrived,
    buildSnackbarMessage: (msg) => {
      const id = msg?.meta?.quoteId ?? msg?.meta?.id;
      return id != null ? `Quote #${id} was accepted` : "Quote accepted";
    },
  });
